import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import { IconHistory } from "@tabler/icons-react";
import { mappingSnapshotStore } from "./MappingSnapshotStore";
import MappingFullSnapshotsModal from "./MappingSnapshotsModal";
import Tooltip from "components/Tooltip";

interface MappingFullSnapshotsTriggerProps {
  fileId: string | undefined;
}

function MappingSnapshotsManager({ fileId }: MappingFullSnapshotsTriggerProps) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    if (!fileId) return;
    mappingSnapshotStore.listSnapshots(fileId, true);
    setIsOpen(true);
  };

  return (
    <>
      <Tooltip content={t("mappingEditor.fullSnapshots")}>
        <Button
          type="gray"
          width="fit-content"
          leadingIcon={<IconHistory />}
          onClick={handleOpen}
          disable={!fileId}
        >
          {t("mappingEditor.fullSnapshots")}
        </Button>
      </Tooltip>
      {fileId && (
        <MappingFullSnapshotsModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          fileId={fileId}
        />
      )}
    </>
  );
}

export default observer(MappingSnapshotsManager);
